// extracted by mini-css-extract-plugin
module.exports = {"desktop-nav":"navigation-desktop_desktop-nav__j1ten","button":"navigation-desktop_button__6oqn0","link":"navigation-desktop_link__zqIop"};